export const EMPTY_LIBRARY_CONDITIONS = [];
